<template>
  <transition name="fade">
    <img
      v-show="showScrollTopButton"
      src="@/assets/ToTopButton.svg"
      height="60"
      width="60"
      @click="moveTop()"
    />
  </transition>
</template>
<script>
const ScrollTopButton = {
  name: 'ScrollTopButton',
  data: () => {
    return {
      showScrollTopButton: false, // Topに戻るボタンの表示フラグ
    }
  },
  props: {
    /** スクロール監視対象のDOMのID属性名 */
    targetId: {type: String, required: true},
    /** 表示切り替え閾値 */
    displayThreshold: {type: Number, required: false, default: 100},
  },
  mounted() {
    this.setScrollEvent()
  },
  methods: {
    /** スクロールイベントの付与 */
    setScrollEvent() {
      const target = document.getElementById(this.targetId)
      if (!target) return
      target.addEventListener('scroll', this.switchDisplayScrollTopButton) // Topへボタンへのイベント追加
    },
    /**
     * Topに戻るボタンの表示切り替え処理(閾値以上スクロールすることで表示)
     * @param {Event} event スクロールイベント
     */
    switchDisplayScrollTopButton(event) {
      const scrollTop = event.target.scrollTop
      this.showScrollTopButton = scrollTop > this.displayThreshold
    },
    /** スクロール最上部へ移動 */
    moveTop() {
      const target = document.getElementById(this.targetId)
      if (!target) return
      const scrollTopX = 0
      const scrollTopY = 0
      target.scrollTo({top: scrollTopX, left: scrollTopY, behavior: 'smooth'})
    },
  },
}
export default ScrollTopButton
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
